
export const SERVICE_TYPES = {
    GameApiService: Symbol.for("GameApiService"),
    UserService: Symbol.for("UserService"),
    StartUpService: Symbol.for("StartUpService"),
    KeyStoreService: Symbol.for("KeyStoreService"),
    ToastService: Symbol.for("ToastService"),
    AnalyticsService: Symbol.for("AnalyticsService"),
}